import { Directive, input, output } from '@angular/core';

@Directive()
export abstract class BaseButton {
  readonly text = input<string>('');
}

@Directive()
export abstract class BaseRouterButton extends BaseButton {
  readonly routerLink = input<string | null>(null);
  readonly class = input<string>('');
}

@Directive()
export abstract class BaseActionButton<T = void> extends BaseButton {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onClick = output<T>();

  readonly class = input<string>('');
}

@Directive()
export abstract class BaseLoadingButton extends BaseActionButton<void> {
  readonly isLoading = input<boolean>(false);
  readonly disabled = input<boolean>(false);
}
